var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.132 18.8h-3.3A20.018 20.018 0 0023.937 0a20.01 20.01 0 00-15.6 7.6c-.3.4-.3.9.1 1.1a.722.722 0 001.1-.2 18 18 0 0114.4-7 18.372 18.372 0 0118.3 17.2h-3.9c-.8 0-1.1.6-.6 1.3l4.3 6.1a.769.769 0 001.4 0l4.3-6.1c.495-.6.295-1.2-.605-1.2zM.844 21.2h3.3A20.018 20.018 0 0024.039 40a20.01 20.01 0 0015.6-7.6.784.784 0 00-.1-1.1.731.731 0 00-1.1.2 18.293 18.293 0 01-14.4 7 18.372 18.372 0 01-18.3-17.2h3.9c.8 0 1.1-.6.6-1.3l-4.3-6.1a.769.769 0 00-1.4 0L.239 20c-.495.6-.195 1.2.605 1.2z",
    opacity: 0.2
  })));
}
export default SvgConnectApp;